import { useQuery } from '@tanstack/react-query';
import { apiListContracts } from '../api/contracts.api';
import type { PaymentDirection } from 'src/types/contract.type';

export function usePaymentContracts(projectId: string, direction?: PaymentDirection) {
    return useQuery({
        queryKey: ['paymentContracts', projectId, direction],
        queryFn: () => apiListContracts(projectId, direction),
        staleTime: 30_000,
    });
}
